export default {
    product:'Products',
    OCR:'OCR',
    Face:"Face Recognition",
    Risk:"Intelligent Risk Control",
    zhinengdaoliu:"Intelligent Drive Traffic",
    blackList:'Black List',
    xinyongbaogao: "Credit Report",
    useCases:"Use Cases",
    News:"News",
    Company:"Company",
    joinUs:"Join Us",
    aboutUs:"About Us",
    contactUs:"Contact Us",
    privacy:"Privacy Policy"
};
